import Formatters from '../../attribute/formatter/Formatters.js';
import AttributeColumnRenderer from "./AttributeColumnRenderer.js";
import I18nResolvers from '../../attribute/i18nResolver/I18nResolvers.js';
export default class BooleanAttributeColumnRenderer extends AttributeColumnRenderer {
  formatAndI18nResolveValue = value => {
    const shouldOverrideValue = this.column.formatter?.overrideValue !== false;
    let resolvedValue = value;
    if (shouldOverrideValue) {
      resolvedValue = Formatters.format(resolvedValue, this.column.formatter);
    } else {
      resolvedValue = I18nResolvers.resolve(resolvedValue, this.column);
    }
    if (resolvedValue == null) {
      resolvedValue = this.column?.cell?.emptyValue;
    }
    return resolvedValue;
  };
}